import React from 'react'
import { Button, Grid, TextField, Typography, Link } from '@mui/material';
import colors from '../../../../colors';
import ButtonGroup from '../../../../general/ButtonGroup';
import { useSelector, useDispatch } from 'react-redux';
import { selectGlobalDataState } from '../../../../../features/global/globalDataSlice'
import { determineUtilityRequest } from '../DetermineUtilityRequest'
import { makeStyles } from '@mui/styles';
import { selectUserInfo } from '../../../../../features/userInfo/userInfoSlice';
import { selectUtilityState, setSentFrom } from '../../../../../features/utilities/utilitySlice';
import { selectMyContractsState, setShouldFillFields } from '../../../../../features/myContracts/myContractsSlice';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { texts } from '../../../../general/texts';


export const Gjobat = (props) => {

    const searchMethods = [
        { display: texts["title-car-plate"], value:'1'},
        { display: texts["title-serie"], value:'2'}
    ]
    const dispatch = useDispatch()
    const userInfo = useSelector(selectUserInfo)
    const utilitySliceState = useSelector(selectUtilityState) 
    const myContractsSliceState = useSelector(selectMyContractsState)
    const navigate = useNavigate()

    const globalDataSliceState = useSelector(selectGlobalDataState)

    const [state, setState] = React.useState({
        utilityName: props.utilityName,
        selectedSearchMethod: searchMethods[0].value,
        token: globalDataSliceState.token,
        plate: '',
        chassisNo: '',
        serie: ''
    })

    const handleButtonClick = (sentFrom) => 
    {
        dispatch(utilityRequest)
        dispatch(setSentFrom(sentFrom))
    }

    const getSearchMethodValue = (value) => 
    {
        setState({...state, selectedSearchMethod: value})
    }

    const utilityRequest = determineUtilityRequest(state)

    const handleTextFieldChange = (prop) => (e) =>
    {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }

    React.useEffect(()=>{
        if(myContractsSliceState.shouldFillFields)
        {
            setState({
                ...state,
                plate: props.selectedContractInfo.contract,
                chassisNo: props.selectedContractInfo.optional
            })
            dispatch(setShouldFillFields(false))
        }
    },[myContractsSliceState.shouldFillFields])
 
    const useStyles = makeStyles({
        mainGrid:{
            padding: '5%',
            paddingTop: '3%'
        },
        utilityName:{
            color:props.utilityInfo.Color,
            fontSize:'1.5rem',
            fontFamily:'GerberaBold',
            paddingTop:'3%',
            paddingLeft:'2%'
        },
        headerBox:{
            backgroundColor: colors.cyan,
            borderRadius:'100%',
            width:'70px',
            height:'70px'
        },
        fieldTitle:{
            color:colors.darkBlue,
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            textAlign:'left'
        },
        button:{
            width:'100%',
            color:colors.white,
            fontSize:'1rem',
            textTransform:'none',
            background:colors.gradientOrange,
            fontFamily:'GerberaBold'
        },
        buttonGrid:{
            marginTop:state.selectedSearchMethod === '2' ? '29%' : 40,
            paddingBottom:2
        },
        image:{
            width:'60%',
        },
        textField:{
            width:'100%'
        }
    })

    const classes = useStyles()

  return (
    <Grid container item rowSpacing={3} className={classes.mainGrid}>
        <Grid container item md={2} xs={2} mt={2} ><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
        <Grid container item md={12} xs={12} >
            <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} ><img src={props.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0].imagePath} className={classes.image}/></Grid>
            <Typography className={classes.utilityName} >{props.utilityInfo.PublicName}</Typography>
        </Grid>
        <Grid container item md={12} xs={12} >
            <Typography className={classes.fieldTitle}>{texts["prompt-choose-search-method"]}</Typography>
        </Grid>
        <Grid container item md={12} xs={12} justifyContent='flex-start' columnSpacing={5} rowSpacing={3} >
            <ButtonGroup defaultButtonStyle={props.defaultButtonStyle} selectedButtonStyle={props.selectedButtonStyle} state={searchMethods} sendValue={getSearchMethodValue}/> 
        </Grid>
        {state.selectedSearchMethod === '1' &&
            <Grid container item rowSpacing={3} >
                <Grid item md={12} xs={12} >
                    <Typography className={classes.fieldTitle} >{texts["car-plate"]}</Typography>
                </Grid>
                <Grid item md={12} xs={12} >
                    <TextField onChange={handleTextFieldChange('plate')} value={state.plate} size={'small'} color={'warning'} label={texts["placeholder-utility-plate"]} className={classes.textField} />
                </Grid>
                <Grid item md={12} xs={12} >
                    <Typography className={classes.fieldTitle}>{texts["car-chase"]}</Typography>
                </Grid>
                <Grid item md={12} xs={12} >
                    <TextField onChange={handleTextFieldChange('chassisNo')} value={state.chassisNo} color='warning' size='small' label={texts["placeholder-utility-chase"]}className={classes.textField}  />
                </Grid>
                <Grid item md={12} xs={12} className={classes.buttonGrid} >
                    <Button 
                      disabled={utilitySliceState.isLoading || (!state.plate || !state.chassisNo)}
                      onClick={()=>{handleButtonClick('contractList')}} className={classes.button} >{texts["title-search"]}</Button>
                </Grid>
            </Grid>
        }
        {state.selectedSearchMethod === '2' &&
            <Grid container item rowSpacing={3} >
                <Grid item md={12} xs={12} >
                    <Typography className={classes.fieldTitle}>{texts["title-serie"]}</Typography>
                </Grid>
                <Grid item md={12} xs={12} >
                    <TextField onChange={handleTextFieldChange('serie')} color='warning' size='small' label={texts["placeholder-serie"]} className={classes.textField}  />
                </Grid>
                <Grid item md={12} xs={12} className={classes.buttonGrid} >
                    <Button
                       disabled={utilitySliceState.isLoading || (!state.serie)}
                     onClick={()=>{handleButtonClick('singleInvoice')}} className={classes.button}>{texts["title-search"]}</Button>
                </Grid>
            </Grid>
        }
    </Grid>
  )
}
export default Gjobat